export const EDIT_SUCCESS = 'Прошивка обновлена';
export const EDIT_ERROR = 'Не удалось обновить прошивку';
